import("../../../assets/js/splide.js")
	.then(({ Splide }) => {
		// Variables
		const sliders = document.querySelectorAll(".content-contact-cards-grid .splide")

		// On mobile: slider. At lg (1024px+): destroy Splide entirely so the CSS grid
		// takes over and all carousel-specific ARIA (role="region", aria-roledescription,
		// slide tab management) is removed from the accessibility tree.
		for (let i = 0; i < sliders.length; i++) {
			const el = sliders[i]
			const label = el.dataset.sliderLabel
			const describedById = el.dataset.sliderDescribedby

			// Set ARIA attrs so Splide can use them for its region role.
			// Cleaned up on destroy so they don't linger as orphaned attrs on a plain div.
			const applyAriaAttrs = () => {
				if (label) el.setAttribute('aria-label', label)
				if (describedById) el.setAttribute('aria-describedby', describedById)
			}
			const removeAriaAttrs = () => {
				el.removeAttribute('aria-label')
				el.removeAttribute('aria-describedby')
			}

			applyAriaAttrs()

			const splide = new Splide(el, {
				type: 'slide',
				arrows: true,
				pagination: true,
				perPage: 1,
				gap: '2rem',
				mediaQuery: 'min',
				breakpoints: {
					1024: {
						destroy: true,
					},
				},
				i18n: {
					slide: 'Contact Card',
				},
			})

			// When Splide destroys itself at lg+, clean up orphaned ARIA attrs.
			// When it remounts (e.g. viewport resizes back to mobile), re-apply them.
			splide.on('destroy', removeAriaAttrs)
			splide.on('mounted', applyAriaAttrs)

			splide.mount()
		}
	})
	.catch((err) => {
		console.error(err)
	});